import Vue from "vue";
import Vuex from "vuex";
import http from "libs/http";
import util from "libs/util";
import user from "@/services/user";
import { getConfig } from "config";

const staticUrl = getConfig("STATICURL");

Vue.use(Vuex);
let step = 0;

const store = new Vuex.Store({
  state: {
    staticUrl: staticUrl,
    navActiveIndex: -1,
    pageLock: [], //是否锁定页面
    userInfo: {}, //用户信息
    isLogin: 0, // 是否登录
    isCheckLogin: 0, // 登录检查是否完成
    selectCourse: {},
    isFlexCenter: 0,
    statInfo: {},
    clientHeight: 600,
    clientWidth: 600,
    knowledgeSigns: [],
    curKnowledge: {},
    knowledgeStatus: false, //是否显示知识点标注
    knowledgeSettings: {},
    globalAudio: null,
    globalAudioRate: 1, //音频速率
    historyStack: [], //历史栈
    historyIndex: -1, //当前页面索引
    menuWay: +sessionStorage.getItem("menuWay") || 0, // 菜单样式
    isCourseMenu: false,
  },
  mutations: {
    setClientHeight(state, height) {
      state.clientHeight = height;
    },
    setClientWidth(state, width) {
      state.clientWidth = width;
    },
    setStatInfo(state, info) {
      state.statInfo = info;
    },
    setIsFlexCenter(state, status) {
      state.isFlexCenter = status;
    },
    setNavActiveIndex(state, index) {
      state.navActiveIndex = index;
    },
    setSelectCourse(state, course) {
      state.selectCourse = course;
    },
    setPageLock(state, lock) {
      const pageLock = state.pageLock || [];
      if (lock) {
        pageLock.push("is-lock");
      } else {
        pageLock.pop();
      }
      state.pageLock = pageLock;
    },
    setIsCheckLogin(state, status) {
      state.isCheckLogin = status;
    },
    setUserInfo(state, userInfo) {
      state.isLogin = userInfo.userId ? 1 : 0;
      util.setStorage("userId", userInfo.userId);
      userInfo = user.getFormatUserInfo(userInfo);
      state.userInfo = userInfo;
    },
    setIsLogin(state, status) {
      state.isLogin = status;
    },
    setMenuWay(state, status) {
      state.menuWay = status;
    },
    setIsCourseMenu(state, status) {
      state.isCourseMenu = status;
    },
    setKnowledgeSigns(state, list) {
      state.knowledgeSigns = list;
    },
    setKnowledgeStatus(state, bol) {
      state.knowledgeStatus = bol;
      this.commit("setKnowledgeSettings", {
        ...state.knowledgeSettings,
        isOpen: true,
      });
    },
    setCurKnowledge(state, val) {
      state.curKnowledge = val;
    },
    setKnowledgeSettings(state, val) {
      state.knowledgeSettings = val;
      state.knowledgeStatus = val.isOpen;
      sessionStorage.setItem("knowSettings", JSON.stringify(val));
    },
    // obj  1】为布尔值时控制播放或暂停;2】为null时销毁音频；3】object为new 初始化
    setGlobalAudio(state, val) {
      console.log("----setGlobalAudio----------???????");
      if (typeof val === "boolean") {
        if (state.globalAudio)
          val ? state.globalAudio.play() : state.globalAudio.pause();
      } else {
        if (!val || !state.globalAudio) state.globalAudio = val;
      }
    },
    setGlobalAudioRate(state, val) {
      state.globalAudioRate = +val;
      sessionStorage.setItem("audioRate", +val);
    },
    setHistoryStack(state, {fullPath,curPath}) {
      console.log(curPath,"============历史栈", fullPath);
      const stack = state.historyStack;
      const idx = state.historyIndex;
      // 后退
      if(stack[idx - 1] == fullPath) {
        console.log('----------------后退',step)
        if(step < 1) {
          step -= 1;
        } else {
          step = -1;
        }
        state.historyIndex -= 1;
        // history.replaceState({ page:path }, name, fullPath);
      } else if(stack[idx + 1] == fullPath) { //前进
        console.log('----------------前进',step)
        if(step > -1) {
          step += 1;
        } else {
          step = 1;
        }
        state.historyIndex += 1;
      } else {
        // 前进或后退超过2步 or 插入的路由和当前路由位置差距大于2，则清空数组重复路由后面所有的值
        console.log(step,'----------------新增')
        const idx = state.historyStack.findIndex(url => url == curPath);
        if(Math.abs(step) > 1 || Math.abs(idx - state.historyStack.length) > 2) {
          if(idx > -1) state.historyStack.splice(idx + 1);
        }
        step = 0;
        // 新增路由
        state.historyStack.push(fullPath);
        state.historyIndex = state.historyStack.length - 1;
      }
      console.log("============历史栈", state.historyStack);
    },
  },
  actions: {
    setClientHeight({ commit }, height) {
      commit("setClientHeight", height);
    },
    setClientWidth({ commit }, width) {
      commit("setClientWidth", width);
    },
    setStatInfo({ commit }, info) {
      commit("setStatInfo", info);
    },
    setIsFlexCenter({ commit }, status) {
      commit("setIsFlexCenter", status);
    },
    setNavActiveIndex({ commit }, index) {
      commit("setNavActiveIndex", index);
    },
    setPageLock({ commit }, lock) {
      commit("setPageLock", lock);
    },
    setSelectCourse({ commit }, course) {
      commit("setSelectCourse", course);
    },
    setIsCheckLogin({ commit }, status) {
      commit("setIsCheckLogin", status);
    },
    setUserInfo({ commit }, userInfo) {
      commit("setUserInfo", userInfo);
    },
    setIsLogin({ commit }, status) {
      commit("setIsLogin", status);
    },
    async queryUserInfo({ commit }) {
      return new Promise(async (resolve, reject) => {
        const res = await http.post("/user/userc/info.json");
        let data = res.data;
        if (res.status == 200) {
          console.log(
            "-----------------queryUserInfo--------------------",
            res
          );
          if (data) {
            commit("setUserInfo", data);
          } else {
            commit("setUserInfo", {});
          }
          commit("setIsCheckLogin", 1);
        }
        resolve(res.data);
      });
    },
    async queryStatInfo({ commit }) {
      return new Promise(async (resolve, reject) => {
        const res = await http.post("/classes/statistics.json");
        let data = res.data || {};
        if (res.status == 200) {
          if (data) {
            commit("setStatInfo", data);
          }
        }
        resolve(res.data);
      });
    },
    async queryKnowledgeSigns({ commit }, courseId) {
      return new Promise(async (resolve, reject) => {
        const res = await http.post("/course/knowledgeInfo.json", { courseId });
        commit("setKnowledgeSigns", res.data || []);
      });
    },
  },
  getters: {
    getClientWidth: (state) => state.clientWidth,
    getClientHeight: (state) => state.clientHeight,
    getStaticUrl: (state) => state.staticUrl,
    getStatInfo: (state) => state.statInfo,
    getIsFlexCenter: (state) => state.isFlexCenter,
    getSelectCourse: (state) => state.selectCourse,
    getNavActiveIndex: (state) => state.navActiveIndex,
    getPageLock: (state) => state.pageLock,
    getUserInfo: (state) => state.userInfo,
    getIsCheckLogin: (state) => state.isCheckLogin,
    getIsLogin: (state) => state.isLogin,
    getKnowledgeSigns: (state) => state.knowledgeSigns,
    getCurKnowledge: (state) => state.curKnowledge,
    getKnowledgeStatus: (state) => state.knowledgeStatus,
    getKnowledgeSettings: (state) => state.knowledgeSettings,
    getGlobalAudio: (state) => state.globalAudio || {},
    getGlobalAudioRate: (state) => state.globalAudioRate,
    getHistoryStack: (state) => state.historyStack,
    getHistoryIndex: (state) => state.historyIndex,
    getMenuWay: (state) => state.menuWay,
    getIsCourseMenu: (state) => state.isCourseMenu,
  },
});

export default store;